export default [
    {
        "id": 1,
        "value": 1,
        "text": 'Consigo usar minha estação meteorológica no sistema?',
        "description" : "Sim! É só entrar em contato com nosso comercial e te mandaremos um orçamento!"
    },
    {
        "id": 2,
        "value": 2,
        "text": 'O que é um ponto?',
        "description" : "O Agroclima PRO é uma solução de previsão geolocalizada. Com base no seu Ponto (coordenada geográfica), serão geradas as previsões. Dependendo da extensão da sua propriedade, será necessário mais de um ponto para abranger toda a área. "
    }
];